import { useState } from "react";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Divider from "@mui/material/Divider";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import ViewColumnOutlinedIcon from "@mui/icons-material/ViewColumnOutlined";
import { ANTECIPACOES_COLUMN_IDS, AntecipacoesColumnId, DEFAULT_ANTECIPACOES_COLUMNS } from "../preferences/types";
import { FIXED_COLUMNS, OPTIONAL_COLUMN_LABELS, toggleColumn } from "./columns";

export type ColumnPickerProps = { visible: AntecipacoesColumnId[]; onChange: (next: AntecipacoesColumnId[]) => void };

export default function ColumnPicker({ visible, onChange }: ColumnPickerProps) {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  return (
    <>
      <Button variant="outlined" startIcon={<ViewColumnOutlinedIcon />} aria-haspopup="menu" onClick={(e) => setAnchor(e.currentTarget)}>
        {`Colunas (${visible.length + FIXED_COLUMNS.length})`}
      </Button>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)} PaperProps={{ sx: { minWidth: 260 } }}>
        <Typography sx={{ px: 2, py: 0.5, fontSize: 12, color: "text.secondary" }}>Colunas visíveis (fica salvo na sua conta)</Typography>
        {FIXED_COLUMNS.map((c) => (
          <MenuItem key={c.id} dense disabled>
            <Checkbox size="small" checked sx={{ p: 0.5, mr: 1 }} inputProps={{ "aria-hidden": true }} tabIndex={-1} />
            <ListItemText primary={c.label} secondary="sempre visível" />
          </MenuItem>
        ))}
        {ANTECIPACOES_COLUMN_IDS.map((id) => (
          <MenuItem key={id} dense role="menuitemcheckbox" aria-checked={visible.includes(id)} onClick={() => onChange(toggleColumn(visible, id))}>
            <Checkbox size="small" checked={visible.includes(id)} sx={{ p: 0.5, mr: 1 }} inputProps={{ "aria-hidden": true }} tabIndex={-1} />
            <ListItemText primary={OPTIONAL_COLUMN_LABELS[id]} />
          </MenuItem>
        ))}
        <Divider />
        <MenuItem dense onClick={() => onChange(DEFAULT_ANTECIPACOES_COLUMNS)}>
          <ListItemIcon><RestartAltIcon fontSize="small" /></ListItemIcon>
          Restaurar padrão
        </MenuItem>
      </Menu>
    </>
  );
}
